import { clientConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { MachineWithSkills } from "./get-machines-with-skills";

export const getMachineWithSkills = async (
  namespace: string,
  machineId: string,
): Promise<MachineWithSkills> => {
  const url = clientConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();
  try {
    const response = await axios.get<MachineWithSkills>(
      `${url}/api/v4/ns/${namespace}/machines-skills/${encodeURIComponent(
        machineId,
      )}`,
      { headers },
    );

    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      console.error("Axios error:", error);
      throw error;
    }

    throw new Error(
      "An unexpected error occurred while fetching machine skills.",
    );
  }
};
